
import { 
    GET_CASE_COUNTS,
    GET_CASE_COUNTS_SUCCESS,
    GET_CASE_COUNTS_FAIL, 
    GET_CASE_COUNTS_RESET,
} from "../actions/getCaseCountsAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const getCaseCountsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CASE_COUNTS:
            return {
                ...state,
                apiState: "loading",
            };
        case GET_CASE_COUNTS_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case GET_CASE_COUNTS_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case GET_CASE_COUNTS_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default getCaseCountsReducer;
